import {
  AVG_CHURN_AMOUNT,
  AVG_CONTRACTION_AMOUNT,
  AVG_EXPANSION_AMOUNT,
  AVG_REACTIVATION_AMOUNT,
  AVG_SALES_PRICE,
} from "./exampleData";
import { CHART_NEGATIVE } from "./chartTheme";
import AmountBarChart from "./AmountBarChart";

/** Single-series dollar-amount charts for the average-amount metric family. */

export const AverageSalesPriceChart = () => (
  <AmountBarChart
    caption="Average sales price sits around $2,300–$2,600 — the typical New MRR a new customer brings. A rising ASP means new customers are choosing higher-value plans."
    data={AVG_SALES_PRICE}
    seriesName="Avg sales price"
  />
);

export const AverageExpansionAmountChart = () => (
  <AmountBarChart
    caption="The typical upgrade adds $240–$330 of MRR. A rising average means customers are expanding in bigger steps, not just more often."
    data={AVG_EXPANSION_AMOUNT}
    seriesName="Avg expansion"
  />
);

export const AverageContractionAmountChart = () => (
  <AmountBarChart
    caption="The typical downgrade sheds $150–$250 of MRR. A rising average is a sharper warning than small trims — customers are cutting deeper."
    data={AVG_CONTRACTION_AMOUNT}
    seriesName="Avg contraction"
    color={CHART_NEGATIVE}
  />
);

export const AverageChurnAmountChart = () => (
  <AmountBarChart
    caption="The typical cancellation costs around $200 of MRR. A rising average means you're losing bigger customers, where each loss hurts more."
    data={AVG_CHURN_AMOUNT}
    seriesName="Avg churn"
    color={CHART_NEGATIVE}
  />
);

export const AverageReactivationAmountChart = () => (
  <AmountBarChart
    caption="Returning customers come back on about $160–$260 of MRR. A rising average means they're reactivating on richer plans than they left on."
    data={AVG_REACTIVATION_AMOUNT}
    seriesName="Avg reactivation"
  />
);
